<template>
  <div>
    <tablita
      :cols="columnas"
      :configuracion="configuracion_tabla"
      @cargar="cargarProgramas($event)"
      @cargar_url="cargarUrl($event)"
      @nuevo="nuevo($event)"
      @ver="ver($event)"
      @copiar="copiar($event)"
      @editar="editar($event)"
      @eliminar="eliminar($event)"
      @refresh="refrescar($event)"
    ></tablita>
    <vue-confirm-dialog></vue-confirm-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Tabla from "../../components/Tabla/Tabla";
export default {
  data: () => ({
    configuracion_tabla: {
      titulo: "Listado de Programas de Retiro",
      titulo_boton: "Crear programa de retiro",
      clase_boton_crear: "btn-success",
      btn_nuevo: true
    },
    columnas: [
      {
        key: "fecha",
        label: "Fecha",
        busqueda: "",
        tipo: "date",
        path: "fecha",
        searchable: true
      },
      {
        key: "finalizado",
        label: "Estado",
        busqueda: "",
        tipo: "html_select",
        path: "finalizado_html",
        opciones: [
          { id: 0, value: "Pendiente" },
          { id: 1, value: "Finalizado" },
        ],
        valor_opcion: "id",
        label_opcion: "value",
        searchable: true
      },
    ],
    botones: [
      {
        label: "Ver detalle",
        clase: "btn-primary",
        evento: "ver",
        icono: "fa fa-eye"
      },
      {
        label: "Copiar",
        clase: "btn-light",
        evento: "copiar",
        icono: "fa fa-copy"
      },
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen"
      }
    ],
    lista: [],
    links: [],
    botones_restringidos: []
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: []
    });

    // TODO: Cambiar permiso de ser necesario
    if (
      this.verificar_permiso(
        "ROMANA_ProgramaRetiroController_eliminar_programa"
      )
    ) {
      this.botones_restringidos.push({
        label: "Eliminar",
        clase: "btn-danger",
        evento: "eliminar",
        icono: "fas fa-trash",
        permiso: "ROMANA_ProgramaRetiroController_eliminar_programa"
      });
    }
    this.$emit("cargar");
  },
  methods: {
    async cargarProgramas($event) {
      this.$emit("spinner", true);
      const url = `${this.api}/programa_retiro${$event}`;
      this.pagina_actual = url;
      this.lista = [];
      await this.axios
        .get(url, this.cabeceras_json)
        .then(res => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
            botones_restringidos: this.botones_restringidos
          });
        })
        .catch(e => {
          console.log(e);
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargarUrl(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then(res => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            this.setear_lista({ lista: this.lista, links: this.links });
          })
          .catch(e => {
            console.log(e);
          });
        this.$emit("spinner", false);
      }
    },
    nuevo() {
      this.$router.push(`/programa_retiro/generar`);
    },

    ver({ item }) {
      this.$router.push(`/programa_retiro/${item.id}`);
    },

    editar({ item }) {
      this.$router.push(`/programa_retiro/generar/${item.id}`);
    },

    eliminar({ item }) {
      this.$confirm({
        title: `Está a punto de eliminar el programa de retiro con fecha ${this.$moment(
          item.fecha
        ).format("DD-MM-YYYY")}`,
        button: {
          no: "No",
          yes: "Sí, eliminar"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: async confirm => {
          if (confirm) {
            await this.axios
              .delete(
                `${this.api}/programa_retiro/${item.id}`,
                this.cabeceras_json
              )
              .then(res => {
                this.cargarProgramas("");
              })
              .catch(e => {
                console.log(e);
              });
          }
        }
      });
    },
    copiar({ item }) {
      this.$router.push({name: 'programa_retiro_generar', params: {id_copia: item.id}});
    },
    refrescar() {
      this.columnas.forEach(columna => {
        if (columna.busqueda) columna.busqueda = "";
      });
      this.$emit("cargar");
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"])
  },
  components: {
    tablita: Tabla
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),

    path() {
      return this.$router.currentRoute.path;
    }
  }
};
</script>
